module.exports = __webpack_public_path__ + "img/icon-doinsport.798c6b9d.svg";